// @flow

import React, {useEffect} from 'react';

import {Link, useHistory} from 'react-router-dom';
import {IconButton, Typography, makeStyles} from '@material-ui/core';

import {ArrowBack} from '@material-ui/icons';
import {usePage} from '../../../page/utils';

import CheckoutInput from '../components/CheckoutInput/CheckoutInput';

import {useTypedSelector} from '../../../../store';
import type {Theme} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    margin: theme.spacing(2, 0),
    display: 'flex',
    gap: '8px',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    // [theme.breakpoints.up('md')]: {
    //   fontSize: 22,
    // },
  },
  flex: {
    display: 'flex',
  },
  bgForm: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2, 3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    overflow: 'hidden',
    background: 'white',
  },
}));

export default usePage(CheckoutConfig, 'Checkout Config');

function CheckoutConfig() {
  const classes = useStyles();
  const history = useHistory();
  const saveSuccess = useTypedSelector(
    state => state.salesProcessConfig.saveCheckoutInputSuccess
  );
  useEffect(() => {
    if (saveSuccess) history.push('/configure/sales-process');
  }, [history, saveSuccess]);

  return (
    <div>
      <header className={classes.header}>
        <Link to="/configure/sales-process">
          <IconButton variant="contained" size="small">
            <ArrowBack />
          </IconButton>
        </Link>
        <Typography className={classes.title}>
          Sección con Campos Personalizables
        </Typography>
      </header>

      <div className={classes.bgForm}>
        <CheckoutInput />
      </div>
    </div>
  );
}
